module.exports = __webpack_public_path__ + "img/9b5f0c9fc850e2d4bf2ed961d1ba07b9.png";